import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findUserQrcodes = (headers, params) => {
    const val = {
        first: params.first,
        rows: params.rows,
        page: params.page,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        filters: {
            username: { ...params.filters.username },
        },
    };
    let query = buildQuery(val, []);

    if (params?.filters?.fromDate?.value) {
        query += `${val.filters.username.value ? ";" : ""}createdDate=ge=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params?.filters?.toDate?.value) {
        const toDateVal = new Date(new Date(params?.filters.toDate.value).setDate(new Date(params?.filters.toDate.value).getDate() + 1));
        query += `;createdDate=le=${formatDate(toDateVal)}`;
    }

    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/user-qrcode${query}`, {
        headers,
    });
};
